<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择工序"
    width="800px"
    top="8vh"
  >
    <TableSelect
      ref="tableSelect"
      :filter="filter"
      :columns="columns"
      module="basic"
      url="rtProcess"
      @select="selectProcedure"
      selReset
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="编号" prop="processNo">
            <el-input v-model.trim="filter.processNo" placeholder="请输入工序编号" clearable />
          </el-form-item>
          <el-form-item label="名称" prop="processName">
            <el-input v-model.trim="filter.processName" placeholder="请输入工序名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {
        processNo: "",
        processName: "",
      },
      columns: [
        {
          title: "编号",
          key: "processNo",
          width: 110,
          align: "center",
        },
        {
          title: "名称",
          key: "processName",
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    open(routeId) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.filter.routeId = routeId;
        this.$refs.tableSelect.loadData();
      });
    },

    selectProcedure(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },

    resetHandle(filter) {
      this.filter = filter;
      this.$refs.form.resetFields();
      this.$refs.tableSelect.loadData();
    },
  },
};
</script>
